module.exports = __webpack_public_path__ + "static/media/Healer Might.07c936b6.jpg";